import {environment} from "../../environments/environment";

export class HostUtil {
  public static getDashboardSiteUrl(): string {
    const useSSL: boolean = environment.sites.userDashboard.useSSL;
    const protocol: string = this.getHttpProtocol(useSSL);
    const url: string = environment.sites.userDashboard.url;
    const port: number | null = this.getPort(environment.sites.userDashboard.port);
    return this.generateUrl(protocol, url, port);
  }

  public static getVendorDashboardSiteUrl(): string {
    const useSSL: boolean = environment.sites.vendorDashboard.useSSL;
    const protocol: string = this.getHttpProtocol(useSSL);
    const url: string = environment.sites.vendorDashboard.url;
    const port: number | null = this.getPort(environment.sites.vendorDashboard.port);
    return this.generateUrl(protocol, url, port);
  }

  public static getBusinessPortalDashboardSiteUrl(): string {
    const useSSL: boolean = environment.sites.businessPortalDashboard.useSSL;
    const protocol: string = this.getHttpProtocol(useSSL);
    const url: string = environment.sites.businessPortalDashboard.url;
    const port: number | null = this.getPort(environment.sites.businessPortalDashboard.port);
    return this.generateUrl(protocol, url, port);
  }

  public static getAuthenticationApiEndpointUrl(): string {
    const useSSL: boolean = environment.api.authentication.useSSL;
    const protocol: string = this.getHttpProtocol(useSSL);
    const url: string = environment.api.authentication.url;
    const port: number | null = this.getPort(environment.api.authentication.port);
    return this.generateUrl(protocol, url, port);
  }

  public static getUserApiEndpointUrl(): string {
    const useSSL: boolean = environment.api.user.useSSL;
    const protocol: string = this.getHttpProtocol(useSSL);
    const url: string = environment.api.user.url;
    const port: number | null = this.getPort(environment.api.user.port);
    return this.generateUrl(protocol, url, port);
  }

  public static getBillingApiEndpointUrl(): string {
    const useSSL: boolean = environment.api.billing.useSSL;
    const protocol: string = this.getHttpProtocol(useSSL);
    const url: string = environment.api.billing.url;
    const port: number | null = this.getPort(environment.api.billing.port);
    return this.generateUrl(protocol, url, port);
  }

  public static getRegistryApiEndpointUrl(): string {
    const useSSL: boolean = environment.api.registry.useSSL;
    const protocol: string = this.getHttpProtocol(useSSL);
    const url: string = environment.api.registry.url;
    const port: number | null = this.getPort(environment.api.registry.port);
    return this.generateUrl(protocol, url, port);
  }

  public static getApplicationApiEndpointUrl(): string {
    const useSSL: boolean = environment.api.application.useSSL;
    const protocol: string = this.getHttpProtocol(useSSL);
    const url: string = environment.api.application.url;
    const port: number | null = this.getPort(environment.api.application.port);
    return this.generateUrl(protocol, url, port);
  }

  public static getAuthenticationSiteUrl(queries?: {}): string {
    const useSSL: boolean = environment.sites.authentication.useSSL;
    const protocol: string = this.getHttpProtocol(useSSL);
    const url: string = environment.sites.authentication.url;
    const port: number | null = this.getPort(environment.sites.authentication.port);
    return this.generateUrl(protocol, url, port, queries);
  }

  private static getPort(port?: number): number | null {
    if (port === undefined || port === 80 || port === 8080 || port === 443) {
      return null;
    }
    return port;
  }

  private static getHttpProtocol(useSSL: boolean): string {
    if (useSSL) {
      return "https"
    } else {
      return "http"
    }
  }

  private static getWebsocketProtocol(useSSL: boolean): string {
    if (useSSL) {
      return "wss"
    } else {
      return "ws"
    }
  }

  private static generateUrl(
    protocol: string,
    url: string,
    port: number | null,
    queries?: Record<string, string>
  ): string {
    let generatedUrl: string;

    if (port !== null) {
      generatedUrl = `${protocol}://${url}:${port}`
    } else {
      generatedUrl = `${protocol}://${url}`
    }

    if (Object.keys(queries || {}).length > 0) {
      generatedUrl += "?";

      Object.entries(queries!).forEach((
        [key, value]: [string, string],
        index: number
      ): void => {
        if (index > 0) {
          generatedUrl += `&`;
        }
        generatedUrl += `${key}=${value}`;
      })
    }

    return generatedUrl;
  }
}
